import React from 'react';

const Loader = () => {
    return (
        <div className="d-flex justify-content-center mt-5">
            <div className="spinner-border" role="status">
                <span className="visually-hidden"></span>
            </div>
        </div>
    );
};

export default Loader;